import { useReturnToPrevious } from "./useReturnToPrevious";
import { useResourceContext, useCreatePath } from "ra-core";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export const MobileBackButton = (props: { resource?: string; to?: string }) => {
  const resource = useResourceContext(props);
  const createPath = useCreatePath();
  const { to } = props;
  const finalTo =
    to ??
    createPath({
      resource,
      type: "list",
    });

  const goBack = useReturnToPrevious(finalTo);

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="rounded-full"
      onClick={(e) => {
        e.preventDefault();
        goBack();
      }}
    >
      <ChevronLeft className="size-6" />
      <span className="sr-only">Назад</span>
    </Button>
  );
};
